/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlyTemperature.vue?vue&type=template&id=0ef6769a&scoped=true&"
import script from "./MonthlyTemperature.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonthlyTemperature.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonthlyTemperature.vue?vue&type=style&index=0&id=0ef6769a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef6769a",
  null
  
)

export default component.exports